/**
 * Combined multi-language-translation Q&A set (Wave 1 + Wave 2 + Wave 3),
 * de-duplicated by slug. Every /translation question surface (hub,
 * /translation/q/$slug, sitemap, AI feeds) reads from here so a new wave
 * lands everywhere at once.
 */
import { MLT_QA, type MltQA } from "./questions-500";
import { MLT_QA_WAVE2 } from "./questions-wave2";
import { MLT_QA_WAVE3 } from "./questions-wave3";
import { liftToFloor } from "../_qa/topup-merge";
import { MLT_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: MltQA[] = [];
const seen = new Set<string>();
for (const qa of [...MLT_QA, ...MLT_QA_WAVE2, ...MLT_QA_WAVE3]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<MltQA["cluster"], MltQA>(merged, {
  prefix: "mlt-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 รูปแบบคำแปลและการรับรองที่ผู้รับยอมรับเปลี่ยนได้ ควรยืนยันก่อนเริ่มงาน เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "หน่วยงานผู้รับคำแปล",
  clusterTh: "งานแปลเอกสารหลายภาษา",
  primary: MLT_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "troubleshoot", location: "language" },
});

export const MLT_QA_ALL: MltQA[] = merged;

export const MLT_QA_ALL_BY_SLUG: Record<string, MltQA> = Object.fromEntries(
  MLT_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const MLT_QA_PHRASING_COUNT = MLT_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
